export interface IAppsEngagementTableColumns {
    Id: string;
    Title: string;
}

export enum EExportOptions {
    EXCEL,
    PNG,
    DASHBOARD,
    WESHARE,
}
